module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Batsmen: Total Runs")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 batsmen with most runs scored across all\n      the seasons of IPL.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Virat Kohli of Royal Challengers Banglore has scored 4115 runs, the most\n        for any batsman in IPL.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Suresh Raina of Chennai Super kings is second on the list by a difference of\n        only 9 runs at 4106.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6645b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BatsmanTotalRuns.vue
// module id = 399
// module chunks = 1